import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Unsubscribe.css';
import Header from '../components/header/header';
import Footer from '../components/Footer/Footer';

const Unsubscribe = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);

    try {
      const trimmedEmail = email.trim();
      
      // Save to suppression.txt file (MD5 hashed)
      try {
        const suppressionResponse = await fetch('/api/suppression', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: trimmedEmail
          })
        });
        
        if (!suppressionResponse.ok) {
          console.warn('Failed to add email to suppression list:', await suppressionResponse.text());
          // Continue anyway - don't fail the unsubscribe if suppression list fails
        }
      } catch (suppressionError) {
        console.warn('Error adding to suppression list:', suppressionError);
        // Continue anyway - don't fail the unsubscribe if suppression list fails
      }

      // Save unsubscribe email to Formspree (keep existing functionality)
      const apiUrl = process.env.REACT_APP_UNSUBSCRIBE_API_URL || 'https://formspree.io/f/myzndzdj';
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          email: trimmedEmail,
          action: 'unsubscribe',
          timestamp: new Date().toISOString()
        })
      });

      const responseData = await response.json();

      if (response.ok) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/home');
        }, 3000);
      } else {
        console.error('Unsubscribe failed:', responseData);
        throw new Error(responseData.error || 'Failed to unsubscribe. Please try again later.');
      }
    } catch (err) {
      console.error('Error unsubscribing:', err);
      setError(err.message || 'Something went wrong. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="unsubscribe-page">
      <Header />
      <div className="unsubscribe-container">

        
        <div className="unsubscribe-content">
          <div className="unsubscribe-header">
            <h1>Unsubscribe</h1>
            <p>Enter your email address to unsubscribe from our communications</p>
          </div>

          {success ? (
            <div className="unsubscribe-success">
              <div className="success-icon">✓</div>
              <h2>You have been successfully unsubscribed.</h2>
              <p>You will be redirected to the home page shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="unsubscribe-form">
              <div className="form-group">
                <label htmlFor="unsubscribe-email">Email Address</label>
                <input
                  id="unsubscribe-email"
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError('');
                  }}
                  placeholder="Enter your email"
                  autoFocus
                  disabled={isSubmitting}
                />
              </div>
              
              {error && (
                <div className="unsubscribe-error">
                  {error}
                </div>
              )}

              <button 
                type="submit" 
                className="unsubscribe-submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Unsubscribing...' : 'Unsubscribe'}
              </button>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Unsubscribe;

